module.exports = __webpack_public_path__ + "static/media/YM01_9.bc97651a.jpg";